/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useQuery } from '@apollo/client';

export const useFetchSubscriptions = () => {

    const FETCH_SUBSCRIPTION_GQL = gql`
        query FetchProductSubscriptionByProductTag {
            fetchSubscriptions {
                firstName
                lastName
                preferredName
                emailAddress
                province
                preferredLanguage
                subscribeNews
                preferences
            }
        }
    `

    const { data, loading, error } = useQuery(FETCH_SUBSCRIPTION_GQL, {
        fetchPolicy:"network-only",
        context:{clientName:"notification"}
      });
    
      return { data, loading, error };
}